import { AttributePropertyValues, IAttribute, Attribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareCategoryAttributePropertyValues =
    AttributePropertyValues
    & {
        category: string;
    };

export type ClientAwareCategoryAttributeProperties = {
    [name in keyof ClientAwareCategoryAttributePropertyValues]?: ClientAwareCategoryAttributePropertyValues[name];
};

export interface IClientAwareCategoryAttribute extends IAttribute, ClientAwareCategoryAttributeProperties
{
}

export class ClientAwareCategoryAttribute extends Attribute implements IClientAwareCategoryAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareCategoryAttribute";
    public static override className = "ClientAwareCategoryAttribute";

    public category?: string;

    constructor(propertyValues?: Partial<ClientAwareCategoryAttributePropertyValues>)
    {
        super(propertyValues);

        this.category = propertyValues?.category;
    }
}
